/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// This is the "select multiple" functionality for the contact list

App.ready(() => App.select_multiple.init());

App.select_multiple = {
  init() {
    this.init_local_storage();

    App.select_multiple.check_current_group();

    return $(document)
      .off("click", ".js-sm-toggle", App.select_multiple.toggle)
      .on("click", ".js-sm-toggle", App.select_multiple.toggle);
  },

  init_local_storage() {
    if (!localStorage.selectedContacts) { localStorage.selectedContacts = "{}"; }
    return localStorage.sm_current_group || (localStorage.sm_current_group = "");
  },

  check_current_group() {
    if (localStorage.sm_current_group.toString() !== App.groups.current_id().toString()) {
      App.select_multiple.remove_all();
    }

    return localStorage.sm_current_group = App.groups.current_id();
  },

  active() {
    return $(".js-content-main").hasClass("sm-enabled");
  },

  toggle(evt) {
    evt.preventDefault();
    const $btn = $(this);
    if ($(".js-content-main").hasClass("sm-enabled")) {
      return App.select_multiple.disable($btn);
    } else {
      return App.select_multiple.enable($btn);
    }
  },

  reload() {
    App.select_multiple.check_current_group();

    // $(".js-sm-toggle") will be missing on groups with < 2 contact_memberships
    if ($(".js-content-main").hasClass("sm-enabled")) {
      if ($(".js-sm-toggle")[0]) {
        return App.select_multiple.enable($(".js-sm-toggle"));
      } else {
        return App.select_multiple.disable();
      }
    }
  },

  // Turn off the select_multiple functionality and hide right-panel
  disable(btn) {
    App.right_panel.close();

    $(".js-sm-panel").removeClass("open");
    $(".js-content-main").removeClass("sm-enabled");

    if (btn) {
      const sm_container = $(btn.attr("data-sm-container"));
      App.select_multiple.unlinkify_rows(sm_container);
    }

    return App.select_multiple.remove_all();
  },

  // Turn on the select_multiple functionality and show right-panel
  enable(btn) {
    return App.right_panel.load(btn.attr("href"), function() {
      App.select_multiple.loaded(btn);
      return App.groupings.init();
    });
  },

  loaded(btn) {
    App.select_multiple.set_remove_group_visibility();
    $(".js-content-main").addClass("sm-enabled");
    const sm_container = $(btn.attr("data-sm-container"));
    App.select_multiple.linkify_rows(sm_container);
    return App.select_multiple.restore_selected(sm_container);
  },

  // If we're on the all_group, hide the remove_from_group button
  set_remove_group_visibility() {
    if (App.groups.is_all_group()) {
      return $(".js-remove-multiple-from-group").hide();
    } else {
      return $(".js-remove-multiple-from-group").show();
    }
  },

  // Disable normal link action on the rows, and instead make clicks
  // anywhere on the row act as a .fancy-checkbox label click
  linkify_rows(sm_container) {
    return sm_container.on("click", "a, td, tr, li", App.select_multiple.row_clicked);
  },

  // Restore normal link action on rows
  unlinkify_rows(sm_container) {
    return sm_container.off("click", "a, td, tr, li", App.select_multiple.row_clicked);
  },

  row_clicked(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const parent = $(this).closest("tr, li");
    const cb     = parent.find(".fancy-checkbox");
    cb.prop("checked", !cb.prop("checked"));
    const contact_json = App.select_multiple.contact_json(parent);

    if (cb.is(":checked")) {
      App.select_multiple.add_contact(contact_json);
    } else {
      App.select_multiple.remove_contact(contact_json);
    }

    return App.select_multiple.update_count();
  },

  // After the side panel is loaded, populate any previously selected
  restore_selected(sm_container) {
    const existing_json = JSON.parse(localStorage.selectedContacts);
    // console.log "in restore_selected, existing_json: ", existing_json
    for (var k in existing_json) {
      var v = existing_json[k];
      App.select_multiple.add_contact(v);
    }
    return App.select_multiple.update_count();
  },

  remove_all() {
    const existing_json = JSON.parse(localStorage.selectedContacts);
    for (var k in existing_json) {
      var v = existing_json[k];
      App.select_multiple.remove_contact(v);
    }
    return App.select_multiple.update_count();
  },


  contact_json(contact_element) {
    contact_element = $(contact_element);
    return {
      html_id: contact_element.attr("id"),
      name: contact_element.find(".name").text(),
      number: contact_element.find(".number").text(),
      email: contact_element.find(".email").text()
    };
  },

  // Add the clicked contact to the right-panel
  //
  // The right panel expects an LI to be created:
  //
  // %li.sm-contact(id="sm-contact-#{contact_id}")
  //   .name Joe Smith
  //   .number (555) 333-4444
  //   .email foo@bar.com
  //
  add_contact(contact_json) {
    // console.log "in add_contact: ", contact_json
    App.select_multiple.store_json(contact_json);

    const contact_id = contact_json.html_id;
    const record_id  = contact_id.replace(/\D/g, "");
    const contact_element = $("#"+contact_id);

    if (contact_element[0]) {
      contact_element.addClass("selected");
      contact_element.find(".js-sm-wrapper input").prop("checked", true);
    }

    if ($("#sm-" + contact_id).length === 0) {
      // Build with .text() — name/number/email are user-controlled and must not be parsed as HTML
      const html = $("<li>", { class: "sm-contact", id: "sm-" + contact_id, "data-contact-membership-id": record_id })
                .append($("<div>", { class: "name" }).text(contact_json.name))
                .append($("<div>", { class: "number" }).text(contact_json.number))
                .append($("<div>", { class: "email" }).text(contact_json.email));

      return $(".js-sm-contacts").append(html);
    }
  },

  remove_contact(contact_json) {
    App.select_multiple.remove_json(contact_json);

    const contact_id = contact_json.html_id;
    const contact_element = $("#"+contact_id);
    contact_element.removeClass("selected");
    contact_element.find(".js-sm-wrapper input").prop("checked", false);
    return $("#sm-" + contact_id).remove();
  },

  // Add the contact_json to localStorage if it doesn't exist already
  store_json(contact_json) {
    const existing_json = JSON.parse(localStorage.selectedContacts);
    existing_json[contact_json.html_id] = contact_json;
    return localStorage.selectedContacts = JSON.stringify(existing_json);
  },

  remove_json(contact_json) {
    if (localStorage.selectedContacts) {
      const existing_json = JSON.parse(localStorage.selectedContacts);
      delete existing_json[contact_json.html_id];
      return localStorage.selectedContacts = JSON.stringify(existing_json);
    }
  },

  update_count() {
    const n = $(".js-sm-contacts li").length;
    let contact = " Contact";
    if (n !== 1) { contact += "s"; }
    return $(".sm-title").text(n + contact + " Selected");
  },

  get_selected_contact_membership_ids() {
    const contact_membership_ids = [];

    const existing_json = JSON.parse(localStorage.selectedContacts);
    // console.log "in get_selected_contact_membership_ids, existing_json: ", existing_json
    for (var k in existing_json) {
      var v = existing_json[k];
      contact_membership_ids.push(k.replace(/\D/g, ""));
    }

    return contact_membership_ids;
  }
};
